<template>
  <component
    :is="isOuterLink ? 'a' : NuxtLink"
    v-bind="isOuterLink ? { href: link, target: '_blank' } : { to: link }"
    class="relative overflow-hidden rounded-xl"
  >
    <div>
      <img v-lazy-load :src="src" alt="banner" />
    </div>
    <div v-if="textButton" class="absolute inset-0 flex flex-col">
      <button
        class="mx-auto mb-4 mt-auto w-full max-w-[90%] rounded-xl bg-white-100 p-2 text-center"
      >
        {{ textButton }}
      </button>
    </div>
  </component>
</template>

<script setup>
const NuxtLink = resolveComponent('NuxtLink');

defineProps({
  src: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    required: true,
  },
  textButton: {
    type: String,
    default: '',
  },
  isOuterLink: {
    type: Boolean,
    default: false,
  },
});
</script>
